//= require react
//= require react_ujs
//= require components

import "./aim_init_room"
import "./aim_article"
import React from 'react'


//Rails.start()
//ActiveStorage.start()